import Axios from "helpers/Interceptor"

export const queryDeezerArtists_api = async (query: string) => {
    try {
        const results = await Axios.get(`/deezer/search/artists`, {
            params: {
                q: query
            }
        })
        return results.data
    } catch (error: any) {
        throw error
    }
}

export const queryDeezerArtistsById_api = async (artistId: string) => {
    try {
        const results = await Axios.get(`/deezer/artists/${artistId}`)
        return results.data
    } catch (error: any) {
        throw error
    }
}